<template>
  <div>  
    <ListDialog ref="returnDeliveryDialog" title="返品処理" :buttonNames="rdButtonNames" :captions="rdCaptions" :widths="rdWidths" :showAdd="false" :showRemove="false" :execWithIndex="submitReturnDelivery" :height="235" :width="1000">
      <!-- 返品処理ダイアログ ヘッダ項目 -->
      <template slot="header" slot-scope="{ editor }">
        <EditPanel>
          <template slot="left">
            <ComboBox v-if="isSales==true" title="ワークフロー" :value.sync="rdWorkflowId" :editor="editor" :required="true" :enabled="$api.perms.hasWorkflow('salesDelivery')" list="workflow_salesDelivery" :nullValue="0" @changed="onReturnDeliveryChangeWorkflow()"  tooltip="出荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【出荷管理】になっているデータから選択ができます。" />                            
            <ComboBox v-if="isSales==false" title="ワークフロー(入荷)" :value.sync="rdWorkflowId" :editor="editor" :required="true" :enabled="$api.perms.hasWorkflow('purchaseDelivery')" list="workflow_purchaseDelivery" :nullValue="0" @changed="onReturnDeliveryChangeWorkflow()" tooltip="入荷時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【入荷管理】になっているデータから選択ができます。"/>    
            <ComboBox v-if="isSales==false" title="ワークフロー(仕入)" :value.sync="rdInvoiceWorkflowId" :editor="editor" :required="true"  :enabled="$api.perms.hasWorkflow('purchaseInvoice')" list="workflow_purchaseInvoice"  :nullValue="0" tooltip="仕入計上時に利用できるワークフローを指定します。【ワークフロー】の【フロー区分】が【仕入計上】になっているデータから選択ができます。"/>                           
            <ComboBox title="担当者" :value.sync="rdPic" :editor="editor" :required="true" list="user" tooltip="案件を担当する人を選択します。【ユーザー】に登録されているデータから選択することができます。" />
            <Calendar title="返品日" :value.sync="rdReturnDate" :editor="editor" />
          </template>
        </EditPanel>               
      </template>
      <!-- 返品処理ダイアログ 一覧項目 -->
      <AtcCommodity :slot="rdSlots[0]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.commodity" :enabled="false" />
      <AtcSKU :slot="rdSlots[1]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.sku" :commodity="item.commodity" :enabled="false" />
      <NumericBox :slot="rdSlots[2]" slot-scope="{ item, editor }" :editor="editor" :value.sync="item.quantity" :required="true" more="0" max="99999999.999" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" />
      <TextBox :slot="rdSlots[3]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText1  != usedTypes.CommodityMemo" :value.sync="item.reserveText1" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[3]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText1:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[4]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText2  != usedTypes.CommodityMemo" :value.sync="item.reserveText2" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[4]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText2:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[5]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText3  != usedTypes.CommodityMemo" :value.sync="item.reserveText3" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[5]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText3:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[6]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText4  != usedTypes.CommodityMemo" :value.sync="item.reserveText4" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[6]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText4  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText4:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[7]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText5  != usedTypes.CommodityMemo" :value.sync="item.reserveText5" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[7]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText5  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText5:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[8]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveText6  != usedTypes.CommodityMemo" :value.sync="item.reserveText6" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[8]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveText6  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveText6:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[9]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo1  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo1" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[9]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo1:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[10]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo2  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo2" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[10]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo2:''" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[11]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveMemo3  != usedTypes.CommodityMemo" :value.sync="item.reserveMemo3" :editor="editor" :enabled="false" />
      <TextBox :slot="rdSlots[11]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveMemo3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveMemo3:''" :editor="editor" :enabled="false" />
      <Calendar :slot="rdSlots[12]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate1  != usedTypes.CommodityMemo" :value.sync="item.reserveDate1" :editor="editor" :enabled="false" />
      <Calendar :slot="rdSlots[12]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate1: null" :editor="editor" :enabled="false" />
      <Calendar :slot="rdSlots[13]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate2  != usedTypes.CommodityMemo" :value.sync="item.reserveDate2" :editor="editor" :enabled="false" />
      <Calendar :slot="rdSlots[13]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate2: null" :editor="editor" :enabled="false" />
      <Calendar :slot="rdSlots[14]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveDate3  != usedTypes.CommodityMemo" :value.sync="item.reserveDate3" :editor="editor" :enabled="false" />
      <Calendar :slot="rdSlots[14]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveDate3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveDate3: null" :editor="editor" :enabled="false" />
      <AutoComplete :slot="rdSlots[15]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList1  != usedTypes.CommodityMemo" :value.sync="item.reserveList1" :editor="editor" list="category_41" :enabled="false" path="/master/Category" />
      <AutoComplete :slot="rdSlots[15]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList1  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList1:''" :editor="editor" list="category_41" :enabled="false" path="/master/Category" />
      <AutoComplete :slot="rdSlots[16]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList2  != usedTypes.CommodityMemo" :value.sync="item.reserveList2" :editor="editor" list="category_42" :enabled="false" path="/master/Category" />
      <AutoComplete :slot="rdSlots[16]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList2  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList2:''" :editor="editor" list="category_42" :enabled="false" path="/master/Category" />
      <AutoComplete :slot="rdSlots[17]" slot-scope="{ item, editor }" v-if="tenantSettings.usedTypeDetailReserveList3  != usedTypes.CommodityMemo" :value.sync="item.reserveList3" :editor="editor" list="category_43" :enabled="false" path="/master/Category" />        
      <AutoComplete :slot="rdSlots[17]" slot-scope="{ item, editor }" v-else-if="tenantSettings.usedTypeDetailReserveList3  == usedTypes.CommodityMemo" :value="item.commodity != null ? item.commodity.reserveList3:''" :editor="editor" list="category_43" :enabled="false" path="/master/Category" />        
    </ListDialog>
  </div>
</template>



<script lang="ts">
import { Component, Prop, Vue, Emit } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class ReturnDelivery extends Vue {
  @Prop() public checkedDeliveryItems:Array<Common.DeliveryItem>; 
  @Prop() public parentDelivery:Common.Delivery;
  @Prop() public salesPurchaseFlag:Common.SalesPurchaseFlags;
  @Prop() public parentMainList:Components.ListView;
  public isSales:boolean = false;

  // 返品ダイアログ用プロパティ
  public rdCaptions = new Array();
  public rdWidths = new Array();
  public rdSlots = new Array();
  public rdGridConfig:Common.GridConfiguration = null;
  public rdPic: string = '';
  public rdReturnDate: Date = new Date().getCalendarDate();
  public rdWorkflowId:number = 0;
  public rdInvoiceWorkflowId:number = 0;
  // ワークフロー処理用プロパティ
  public rdButtonNames: Array<string> = null;
  public rdButtonIndexIdArray: Array<{index:number,actionId:number}> =null;
  public tenantSettings: Common.TenantSettings = null;
  public usedTypes = Common.UsedTypes;  

  // 返品処理ダイアログを表示
  public mounted() {
  this.tenantSettings = this.$api.tenantSettings;
  if(this.salesPurchaseFlag == Common.SalesPurchaseFlags.Sales) this.salesMounted();
  else this.purchaseMounted();
  }

  public purchaseMounted(){
    let tenantSettings: Common.TenantSettings = this.$api.tenantSettings;
    this.isSales = false;

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.quantity < 0).length > 0){
      this.$api.modal.show('', '返品の入荷明細が選択されています。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.deliveryFlag == Common.DeliveryFlags.Direct).length > 0){
      this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
      return;
    }
    // 親伝票が指定されている場合、1伝票中の明細に対する返品なためチェック不要
    if(!this.parentDelivery){
      if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
        this.$api.modal.show('', '部門の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.id != this.checkedDeliveryItems[0].delivery.counterpart.id).length > 0){
        this.$api.modal.show('', '仕入先の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.warehouseId != this.checkedDeliveryItems[0].warehouseId).length > 0){
        this.$api.modal.show('', '倉庫の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.projectItemNo != this.checkedDeliveryItems[0].projectItemNo).length > 0){
        this.$api.modal.show('', '案件の異なる入荷明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }      
    }else{
      // 親伝票が指定されている場合そちらで直送の判定を行う（明細側のdeliveryFlagは値が設定されない
      if(this.parentDelivery.deliveryFlag == Common.DeliveryFlags.Direct){
        this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
        return;
      }
    }

    // 明細の予備項目表示の可変対応

    this.rdGridConfig = new Common.GridConfiguration([],0,'col');
    this.rdGridConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('返品数量', 150),
    );
    this.rdGridConfig.setGridItems(...tenantSettings.GetGridItems(true,true,true,false,false));
    this.rdCaptions =this.rdGridConfig.gridCaptions;
    this.rdWidths = this.rdGridConfig.gridWidths;
    this.rdSlots = this.rdGridConfig.gridSlots;

    // プロパティの初期化
    this.rdPic = this.$api.auth.userId;
    this.rdReturnDate = new Date().getCalendarDate();
    this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseDelivery');
    this.rdInvoiceWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_purchaseInvoice');
    this.onReturnDeliveryChangeWorkflow();

    // ダイアログの表示
    var items = this.checkedDeliveryItems.map(item => item.copy());
    (this.$refs.returnDeliveryDialog as Components.ListDialog).items = items;
    (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  public salesMounted(){
    let tenantSettings: Common.TenantSettings = this.$api.tenantSettings;
    this.isSales = true;

    // ダイアログ表示前バリデーション
    if(this.checkedDeliveryItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);      
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.quantity < 0).length > 0){
      this.$api.modal.show('', '返品の請求明細が選択されています。', true, null);
      return;
    }
    if(this.checkedDeliveryItems.filter(item => item.deliveryFlag == Common.DeliveryFlags.Direct).length > 0){
      this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
      return;
    }
    // 親伝票が指定されている場合、1伝票中の明細に対する返品なためチェック不要
    if(!this.parentDelivery){
      if(this.checkedDeliveryItems.filter(item => item.segment.id != this.checkedDeliveryItems[0].segment.id).length > 0){
        this.$api.modal.show('', '部門の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.delivery.counterpart.id != this.checkedDeliveryItems[0].delivery.counterpart.id).length > 0){
        this.$api.modal.show('', '得意先の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.warehouseId != this.checkedDeliveryItems[0].warehouseId).length > 0){
        this.$api.modal.show('', '倉庫の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }
      if(this.checkedDeliveryItems.filter(item => item.projectItemNo != this.checkedDeliveryItems[0].projectItemNo).length > 0){
        this.$api.modal.show('', '案件の異なる請求明細を、同じ返品伝票にまとめることはできません。', true, null);
        return;
      }      
    }else{
      // 親伝票が指定されている場合そちらで直送の判定を行う（明細側のdeliveryFlagは値が設定されない
      if(this.parentDelivery.deliveryFlag == Common.DeliveryFlags.Direct){
        this.$api.modal.show('', '直送の明細は返品処理できません。数量がマイナスの出荷伝票と入荷伝票を新規作成してください。', true, null);
        return;
      }
    }

    // 明細の予備項目表示の可変対応
    this.rdGridConfig = new Common.GridConfiguration([],0, 'col');
    this.rdGridConfig.setGridItems(
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),
      new Common.GridItemConfiguration('返品数量', 150),
    );
    this.rdGridConfig.setGridItems(...tenantSettings.GetGridItems(true,true,true,false,false));
    this.rdCaptions =this.rdGridConfig.gridCaptions;
    this.rdWidths = this.rdGridConfig.gridWidths;
    this.rdSlots = this.rdGridConfig.gridSlots;
    this.rdWorkflowId = this.$api.perms.getDefaultWorkflowId('workflow_salesDelivery');
    this.onReturnDeliveryChangeWorkflow();

    // プロパティの初期化
    if(this.parentDelivery) this.rdPic = this.parentDelivery.counterpart.salesPerson ? this.parentDelivery.counterpart.salesPerson : this.$api.auth.userId;
    else this.rdPic = this.checkedDeliveryItems[0].delivery.counterpart.salesPerson ? this.checkedDeliveryItems[0].delivery.counterpart.salesPerson : this.$api.auth.userId;

    this.rdReturnDate = new Date().getCalendarDate();

    // ダイアログの表示
    var items = this.checkedDeliveryItems.map(item => (item as Common.SalesDeliveryItem).copyReturn());
    (this.$refs.returnDeliveryDialog as Components.ListDialog).items = items;
    (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  public onReturnDeliveryChangeWorkflow(){
    this.rdButtonNames=new Array();
    this.rdButtonIndexIdArray = new Array();
    var buttonIndex = 0;
    this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:0})
    if(this.isSales)this.rdButtonNames.push("出荷保存");
    else this.rdButtonNames.push("入荷保存");
    if(this.rdWorkflowId!=0)
    {
      var actions = this.isSales ? this.$api.perms.getWorkflowActionsHasPermission('salesDelivery', this.rdWorkflowId, Common.DeliveryStatus.SalesDeliveryPostWaiting) : this.$api.perms.getWorkflowActionsHasPermission('purchaseDelivery', this.rdWorkflowId, Common.DeliveryStatus.PurchaseDeliverySaving);
      actions.forEach(action => {
        this.rdButtonNames.push(action.actionName);
        this.rdButtonIndexIdArray.push({index:buttonIndex++,actionId:action.id})
      });
    }

    // ダイアログの表示
    (this.$refs.returnDeliveryDialog as Components.ListDialog).showDialog();
  }

  // 返品処理の実行
  public async submitReturnDelivery(list: Array<Common.DeliveryItem>, index:number) {
   // クエリの設定
    var query = new Common.ReturnDeliveryQuery();
    query.pic = this.rdPic;
    query.deliveryDate = this.rdReturnDate;
    query.workflowId = this.rdWorkflowId;
    query.invoiceWorkflowId = this.rdInvoiceWorkflowId;
    query.deliveryItems = new Array();
    query.baseItems = this.checkedDeliveryItems;
    query.actionId = this.rdButtonIndexIdArray.filter(obj => obj.index==index)[0].actionId;
    if(this.isSales) list.forEach(item =>{
        let returnItem = (item as Common.SalesDeliveryItem).copyReturn();
        if(this.parentDelivery){
          // Deliveryから起動した場合必要な情報がDeliveryItemにないため設定
          returnItem.segment = this.parentDelivery.segment;
          returnItem.warehouse = this.parentDelivery.warehouse;
          returnItem.delivery = this.parentDelivery;
        }
        returnItem.quantity *= -1;
        returnItem.adjustmentQuantity *= -1;
        returnItem.scannedQuantity = 0;
        returnItem.isScanCompleted = false;
        query.deliveryItems.push(returnItem);
      });
      else list.forEach(item =>{
        let returnItem = item.copy();
        if(this.parentDelivery){
          // Deliveryから起動した場合必要な情報がDeliveryItemにないため設定
          returnItem.segment = this.parentDelivery.segment;
          returnItem.warehouse = this.parentDelivery.warehouse;
          returnItem.delivery = this.parentDelivery;
        }
        returnItem.quantity *= -1;
        returnItem.adjustmentQuantity *= -1;
        returnItem.scannedQuantity = 0;
        returnItem.isScanCompleted = false;
        query.deliveryItems.push(returnItem);
      });

    (this.$refs.returnDeliveryDialog as Components.ListDialog).closeDialog();

    return this.$api.execute(query,true).then(res => {
      //何も更新されないが..
      //  (this.$refs.mainList as Components.ListView).reload();
      var returnDelivery = res as Common.Delivery;
      const orderItems = query.deliveryItems
        .filter(item => item.orderItem != null)
        .map(item => item.orderItem as Common.OrderItem);
      const resultMessage = this.isSales ? '以下の出荷伝票が作成されました。' : '以下の入荷伝票が作成されました。';
      const orderLabel = this.isSales ? '受注' : '発注';
      const deliveryLabel = this.isSales ? '出荷' : '入荷';
      const closeMessage = String.format('返品により、紐づく{0}の{1}残数量が戻ります。再度{2}をしない場合はクローズとすることができます。クローズ処理を実施しますか？', orderLabel, orderLabel, deliveryLabel);
      const message = orderItems.length > 0 ? String.format('{0}{1}', resultMessage, closeMessage) : resultMessage;
      const links = [new Common.ModalLink(returnDelivery.deliveryNo, this.isSales ? String.format('/sales/SalesDelivery?deliveryNo={0}',returnDelivery.deliveryNo) : String.format('/purchase/PurchaseDelivery?deliveryNo={0}',returnDelivery.deliveryNo))];
      this.parentMainList.reload();
      if(orderItems.length > 0) this.$api.modal.show('処理結果', message, false, () => {
        const closeQuery = new Common.ReturnedOrderCloseQuery();
        closeQuery.returnDelivery = returnDelivery;
        return this.$api.execute(closeQuery).then(() => {
          this.parentMainList.reload();
          this.$api.modal.show('処理結果', 'クローズ処理が完了しました。', true, null);
          return true;
        }).catch(() => { return false; });
      }, links, '実施する', '実施しない');
      else this.$api.modal.show('処理結果', message, true, null, links);
      return true;
    }).catch(()=>{return false;});    

  }

}
</script>